import { CustomerSpecificOption } from "./customer-specific-option";

export class SavingAgreementCalculateInterest {
  documentNumber: string;
  agreementNumber: string;
  date: string;
  interestAmount: number;
  lateRepaymentFeeAmount: number;
  interestLateRepaymentFeeAmount: number;
  serviceFeeLatePaymentFeeAmount: number;
  serviceFeeAmount: number;
  totalAmount: number;
  currency: string;
  description: string;
  customerSpecificOptions: CustomerSpecificOption[];
}